import { AxiosResponse } from "axios";
import { ApiPesquisa } from "../../Apis/Pesquisa";
import {
  IArquivoForm,
  IDenunciaDTO,
  IDenunciaForm,
  IDesvincularArquivoProps,
} from "../../types/denuncia";

const basePath = "/denuncia";

export class Denuncia {
  static async get(uuidDenuncia: string): Promise<AxiosResponse<IDenunciaDTO>> {
    return ApiPesquisa.get(`${basePath}/${uuidDenuncia}`);
  }
  static async post(form: IDenunciaForm): Promise<AxiosResponse<IDenunciaDTO>> {
    return ApiPesquisa.post(`${basePath}/cadastrar`, form);
  }

  static async vincular_arquivo(
    data: IArquivoForm
  ): Promise<AxiosResponse<IDenunciaDTO>> {
    const { arquivo, uuidDenuncia } = data;

    const formData = new FormData();
    formData.append("file", arquivo);

    return ApiPesquisa.post(
      `${basePath}/${uuidDenuncia}/vincular-arquivo`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  static async desvincular_arquivo(
    data: IDesvincularArquivoProps
  ): Promise<AxiosResponse<IDenunciaDTO>> {
    const { uuidArquivo, uuidDenuncia } = data;
    return ApiPesquisa.post(
      `${basePath}/${uuidDenuncia}/desvincular-arquivo/${uuidArquivo}`
    );
  }
}
